<template>
  <div>
    <div class="hist">
      <div class="slide">
        <mySlide />
      </div>
      <div class="hist-warp">
        <div class="hist-list w1500">
          <!-- <el-tabs type="border-card" v-model="activeName" @tab-click="getTab">
            <el-tab-pane label="所有记录" name="one">
            </el-tab-pane>
            <el-tab-pane label="我的活动记录" name="two">
            </el-tab-pane>
          </el-tabs> -->
          <div class="new-csgo-table">
            <div class="flex flex-ac">
              <div class="table-item" :class="{'table-active':activeName=='one'}" @click="handleClick('one')">所有记录</div>
              <div class="table-item" :class="{'table-active':activeName=='two'}" @click="handleClick('two')">我的活动记录</div>
            </div>
          </div>
          <div class="">
            <ul class="room-box-ul">
              <!-- 1等待 2 中 3 结束 -->
              <li v-for="item in list" :key="item.id" :class="{'bg_1':item.status==1,'bg_2':item.status==2,'bg_3':item.status==3}">
                <div class="roombox-warp">
                  <div class="two flex flex-jc">
                    <div class="room-peo flex flex-ac">
                      <div v-for="(player,pi) in item.player_info" :key="pi" class="pk-warp flex flex-ac">
                        <img :src="player.img" alt="" srcset="" class="pk-true">
                        <img v-if="pi!=(item.player_info.length-1)" src="@/assets/img/fight/vs.png" alt="" srcset="" class="pk-vs">
                        <template v-if="item.status===3">
                          <img v-if="item.winner===player.id" src="@/assets/img/fight/shengli.png" alt="" srcset="" class="shengli">
                          <img v-else src="@/assets/img/fight/shibai.png" alt="" srcset="" class="shengli">
                        </template>
                      </div>
                    </div>
                  </div>
                  <div class="card-footer">
                    <div class="three flex flex-ac flex-jc">
                      <div v-for="(box,bi) in item.boxInfo" :key="bi" class="box-detail">
                        <img :src="box.img_main" />
                        <div class="box-num">{{ bi+1 }}</div>
                      </div>
                    </div>
                    <div class="flex flex-jc">
                      <div class="two-top flex flex-ac">
                        <img src="@/assets/images/money.png" class="money-img" />
                        <span>{{ item.box_price?item.box_price:item.total_price }} </span>
                      </div>
                      <div class="one flex flex-jsb flex-ac">
                        <span class="span1"><span class="span-dian"></span>{{ item.status==1?'等待中':item.status==2?'进行中':'已结束' }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="box-info flex flex-jsb flex-ac">
                    <span class="box-time">{{ item.create_time }}</span>
                    <span class="number">编号:{{ item.room_num }}</span>
                  </div>
                </div>
              </li>
            </ul>
            <empty v-if="list.length===0"></empty>
          </div>
          <div class="csgo-page">
            <el-pagination background layout="prev, pager, next" :total="searchForm.totalSize" :page-size="searchForm.limit" @current-change="currentChange">
            </el-pagination>
          </div>
        </div>
      </div>
      <myhomebot></myhomebot>
    </div>
    <div class="commonBg"></div>
  </div>
</template>

<script>
import empty from "@/g-components/empty.vue";
import myhomebot from "@/components/my_homebot.vue";
import mySlide from "@/g-components/my_slide.vue";
export default {
  components: {
    empty,
    mySlide,
    myhomebot
  },
  data() {
    return {
      activeName: "one",
      searchForm: {
        page: 1,
        totalSize: 0,
        limit: 20,
      },
      list: []
    };
  },
  created() {
    this.getList();
  },
  methods: {
    handleClick(tab) {
      if(this.activeName == tab){
        return 
      }
      this.activeName = tab
      this.searchForm.page = 1
      this.list = []
      this.getList()
    },
    getList() {
      this.$doGet(this.activeName === 'one' ? '/api/hall.Battle/list' : '/api/hall.Battle/myHistoryList', this.searchForm).then((res) => {
        this.searchForm.totalSize = res.data.count
        this.list = res.data.list
      }).catch(() => { })
    },
    //分页 所有记录
    currentChange(value) {
      this.searchForm.page = value
      this.getList();
    },
    goLucky() {
      this.$router.push({
        path: `/fight`,
      });
    },
  },
};
</script>

<style lang="less" scoped>
.hist {
  .room-box-ul {
    margin-top: 20px;
    display: grid;
    gap: 10px;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    li {
      cursor: pointer;
      overflow: hidden;
      background-color: #2b2c37;
      .roombox-warp {
        .one {
          height: 40px;
          padding: 0 15px;
          .span1 {
            color: #999;
            font-size: 14px;
            display: flex;
            align-items: center;
            .span-dian {
              width: 8px;
              height: 8px;
              display: inline-block;
              margin-right: 10px;
              border-radius: 4px;
              background-color: #999;
            }
          }
          .status-img {
            height: 17px;
          }
          .span3 {
            color: #c3c3e2;
            font-size: 14px;
          }
        }
        .two {
          margin: 50px 0 15px;
          .room-peo {
            .pk-warp {
              position: relative;
              .pk-true {
                width: 40px;
                height: 40px;
                border-radius: 50%;
                border: 1px solid #fff;
              }
              .shengli {
                position: absolute;
                height: 38px;
                text-align: center;
                position: absolute;
                top: -38px;
                left: 2px;
              }
              .pk-false {
                width: 40px;
                height: 40px;
                border-radius: 50%;
              }
              .pk-vs {
                width: 17px;
                height: 12px;
                margin: 0 10px;
              }
            }
          }
        }
        .box-info {
          height: 40px;
          padding: 0 10px;
          color: #909399;
          font-size: 12px;
        }
        .card-footer {
          padding: 0 15px;
          .two-top {
            font-size: 16px;
            color: #e9b10e;
            img {
              height: 18px;
              margin-right: 5px;
            }
          }
        }
        .three {
          display: flex;
          flex-wrap: nowrap;
          overflow-x: auto;
          .box-detail {
            position: relative;
            margin-right: 5px;
            img {
              height: 40px;
              width: auto;
              border-radius: 50%;
            }
            .box-num {
              position: absolute;
              top: 0;
              right: -5px;
              width: 15px;
              text-align: center;
              line-height: 15px;
              border-radius: 50%;
              background-color: #e9b10e;
              color: #000;
              font-size: 12px;
            }
          }
        }
        .three::-webkit-scrollbar {
          /*滚动条整体样式*/
          width: 10px;
          /*高宽分别对应横竖滚动条的尺寸*/
          height: 6px;
        }

        .three::-webkit-scrollbar-thumb {
          /*滚动条里面小方块*/
          border-radius: 10px;
          background-color: #4b575c;
        }
        .three::-webkit-scrollbar-track {
          /*滚动条里面轨道*/
          box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
          // background: #243438;
        }
      }
      &.bg_1 {
        border-top: 5px solid #d8372b;
        .roombox-warp {
          .one {
            .span1 {
              color: #d8372b;
              .span-dian {
                background-color: #d8372b;
              }
            }
          }
        }
        // background-image: ;
      }
      &.bg_2 {
        border-top: 5px solid #e9b10e;
        .roombox-warp {
          .one {
            .span1 {
              color: #e9b10e;
              .span-dian {
                background-color: #e9b10e;
              }
            }
          }
        }
      }
      &.bg_3 {
        border-top: 5px solid rgb(153, 153, 153);
      }
    }
  }
}
</style>